import React from 'react'
import { Box, Divider, Grid, useTheme } from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import appassets from '../../../utils/appassets'

export default function StepsView ({ stages, currentStage, matches }) {
  const theme = useTheme()
  return (
    <Grid
      container
      style={{
        display: 'flex',
        justifyContent: 'center',
        background: theme.palette.background.paper,
        borderRadius: 16,
        padding: matches ? '16px 0px' : 24,
        height: matches ? 'fit-content' : '100%',
        marginTop: matches ? '24px' : 0
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          height: '30%',
          justifyContent: 'center',
          alignItems: 'flex-start',
          padding: '16px'
        }}
      >
        {stages.map(item => (
          <Box
            key={item.stepId}
            style={{ marginLeft: item.stepId !== 1 && '25px' }}
          >
            {item.stepId !== stages.length && (
              <Divider
                style={{
                  position: 'relative',
                  top: '18px',
                  left: '35px',
                  border:
                    item.stepId === currentStage.stepId
                      ? `1.5px solid ${theme.palette.primary.main}`
                      : item.stepId < currentStage.stepId
                      ? `1.5px solid ${theme.palette.text.success}`
                      : `1.5px solid ${theme.palette.border.main}`,
                  width: '25px'
                }}
              />
            )}
            <div
              style={{
                display: 'flex',
                color:
                  item.stepId <= currentStage.stepId
                    ? theme.palette.text.light
                    : theme.palette.text.greyLight,
                backgroundColor:
                  item.stepId === currentStage.stepId
                    ? theme.palette.primary.main
                    : item.stepId < currentStage.stepId
                    ? theme.palette.text.success
                    : theme.palette.background.default,

                border:
                  item.stepId === currentStage.stepId
                    ? `1.5px solid ${theme.palette.primary.main}`
                    : item.stepId < currentStage.stepId
                    ? `1.5px solid ${theme.palette.text.success}`
                    : `1.5px solid ${theme.palette.border.main}`,

                borderRadius: '50%',
                width: '35px',
                height: '35px',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              {item.stepId < currentStage.stepId ? (
                <CheckCircleRoundedIcon
                  style={{ color: theme.palette.background.default }}
                />
              ) : (
                <TextBold
                  style={{
                    color:
                      item.stepId === currentStage.stepId
                        ? theme.palette.background.default
                        : theme.palette.text.primary
                  }}
                >
                  {item.stepId}
                </TextBold>
              )}
            </div>
          </Box>
        ))}
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          height: '70%',
          justifyContent: 'center',
          alignItems: 'flex-start',
          padding: '16px'
        }}
      >
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <img src={`${appassets[currentStage.icon]}`} alt='steps' />
          </Grid>

          <Grid
            item
            xs={12}
            textAlign={'center'}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <TextBold style={{ fontSize: '16px', margin: '16px 0px' }}>
              {currentStage.title}
            </TextBold>
          </Grid>
          <Grid
            item
            xs={12}
            textAlign={'center'}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <TextRegular style={{ color: theme.palette.text.greyLight }}>
              {currentStage.description}
            </TextRegular>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
